import types from "./types";

const INITIAL_STATE = {
	privatedocument: null,
	privatedocumentError: null,
	privatedocumentLoading: false,

	//create
	createprivatedocument: null,
	createprivatedocumentError: null,
	createprivatedocumentLoading: false,

	//update
	updateprivatedocument: null,
	updateprivatedocumentError: null,
	updateprivatedocumentLoading: false,

	//delete
	deleteprivatedocument: null,
	deleteprivatedocumentError: null,
	deleteprivatedocumentLoading: false,

	//single item

	singleItem: null,
};

const PrivatedocumentReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_PRIVATEDOCUMENT_START:
			return {
				...state,
				privatedocument: null,
				privatedocumentError: null,
				privatedocumentLoading: true,
			};
		case types.GET_PRIVATEDOCUMENT_SUCCESS:
			return {
				...state,
				privatedocument: action.payload,
				privatedocumentLoading: false,
			};
		case types.GET_PRIVATEDOCUMENT_ERROR:
			return {
				...state,
				privatedocumentError: action.payload,
				privatedocumentLoading: false,
			};
		case types.GET_PRIVATEDOCUMENT_RESET:
			return {
				...state,
				privatedocumentError: null,
				privatedocumentLoading: false,
			};
		//create

		case types.CREATE_PRIVATEDOCUMENT_START:
			return {
				...state,
				createprivatedocument: null,
				createprivatedocumentError: null,
				createprivatedocumentLoading: true,
			};
		case types.CREATE_PRIVATEDOCUMENT_SUCCESS:
			return {
				...state,
				createprivatedocument: action.payload,
				createprivatedocumentLoading: false,
			};
		case types.CREATE_PRIVATEDOCUMENT_ERROR:
			return {
				...state,
				createprivatedocumentError: action.payload,
				createprivatedocumentLoading: false,
			};
		case types.CREATE_PRIVATEDOCUMENT_RESET:
			return {
				...state,
				createprivatedocumentError: null,
				createprivatedocumentLoading: false,
			};
		//delete

		case types.DELETE_PRIVATEDOCUMENT_START:
			return {
				...state,
				deleteprivatedocument: null,
				deleteprivatedocumentError: null,
				deleteprivatedocumentLoading: true,
			};
		case types.DELETE_PRIVATEDOCUMENT_SUCCESS:
			return {
				...state,
				deleteprivatedocument: action.payload,
				deleteprivatedocumentLoading: false,
			};
		case types.DELETE_PRIVATEDOCUMENT_ERROR:
			return {
				...state,
				deleteprivatedocumentError: action.payload,
				deleteprivatedocumentLoading: false,
			};
		case types.DELETE_PRIVATEDOCUMENT_RESET:
			return {
				...state,
				deleteprivatedocument: null,
				deleteprivatedocumentError: null,
				deleteprivatedocumentLoading: false,
			};

		//update
		case types.UPDATE_PRIVATEDOCUMENT_START:
			return {
				...state,
				updateprivatedocument: null,
				updateprivatedocumentError: null,
				updateprivatedocumentLoading: true,
			};
		case types.UPDATE_PRIVATEDOCUMENT_SUCCESS:
			return {
				...state,
				updateprivatedocument: action.payload,
				updateprivatedocumentLoading: false,
			};
		case types.UPDATE_PRIVATEDOCUMENT_ERROR:
			return {
				...state,
				updateprivatedocumentError: action.payload,
				updateprivatedocumentLoading: false,
			};
		case types.UPDATE_PRIVATEDOCUMENT_RESET:
			return {
				...state,
				updateprivatedocument: null,
				updateprivatedocumentError: null,
				updateprivatedocumentLoading: false,
			};
		

		default:
			return { ...state };
	}
};

export default PrivatedocumentReducer;
